'use client';

import { BsHeartFill } from 'react-icons/bs';

export function Divider(): React.JSX.Element {
  return (
    <div className="relative my-8 text-red-500">
      <div aria-hidden="true" className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-border" />
      </div>
      <div className="relative flex justify-center">
        <span className="bg-card px-2 text-muted-foreground">
          <BsHeartFill color="inherit" />
        </span>
      </div>
    </div>
  );
}
